// autoescuelaChatsMock.js (simulador · autoescuela, 2/10/2026) — la sección «Chats» de la demo de
// autoescuela con conversaciones del día a día REALES de una autoescuela con sus alumnos: la semana
// con imagen y botones, el recordatorio con «Confirmar/Cancelar práctica», el hueco liberado, el test de
// teórica, la inscripción a un curso CAP, el aviso de caducidad del CAP, el examen APTO con la reseña,
// «mi ficha», «quiero clase», la factura y alguna pregunta suelta.
//
// TODO CUADRA CON EL RESTO DE LA DEMO: los alumnos (nombre y teléfono) son los de Alumnos
// (mockData.mockAlumnos), las prácticas de la semana salen de mockPracticas (Planificación), el curso
// es la edición «CAP formación continua» de cursosStore y el nombre del negocio, el de los datos
// fiscales (getBusinessName). Fechas SIEMPRE relativas a hoy.
//
// TEXTOS EXACTOS DE PRODUCCIÓN: plantillas copiadas por valor de SYSTEM_TEMPLATES
// (aws_lambdas/c_sendTemplate/index.js) y respuestas de ../mensajes/respuestasBotones.js,
// ../mensajes/testTeoricaPreview.js, c_cursoWhatsapp/mensajes.js y c_processMessage/fichaAlumnoText.js.
// Los mensajes van en español literal en todos los idiomas: es lo que el alumno ve en WhatsApp.
//
// FORMA DE LOS MENSAJES = la del chat real (c_mensajes_optimized): messageType «text», «template»
// (messageBody = JSON { templateData, templateParams, buttonParams }), «interactive» (Flow enviado,
// botón pulsado `button_reply`, respuesta del Flow `flow_completion`), «location», «document».
// Única licencia del simulador: `header_image` (la imagen de la práctica/semana que en la real genera
// c_generateClaseConfirmacion y llega como URL en la cabecera de la plantilla).
import dayjs from "dayjs";
import { SECTOR_DATA_MAP } from "../../../mockData";
import { getBusinessName } from "../preview/templatePreview";
import {
  BOTON,
  SEMANA,
  HUECO,
  FLOW_PEDIR,
  buildAcuseText,
  practicaCancelReply,
  eurosCargo,
  prefijoConext,
} from "../mensajes/respuestasBotones";
import { ejemploTest, testText, CTA_TEST, BOTON_PLANTILLA } from "../mensajes/testTeoricaPreview";
import { getEdicionSync } from "../cursosStore";
import { getReminderConfig } from "../reminderConfigStore";

export const AE_CHAT_COMPANY = "simulator-demo";
const MIN = 60_000;

// ── Plantillas (copias por valor de SYSTEM_TEMPLATES de c_sendTemplate) ─────────────────────────
const PH = { header_handle: ["PLACEHOLDER"] };
export const AE_TEMPLATES = {
  practicas_semana_crm_trial_img_btn: {
    name: "practicas_semana_crm_trial_img_btn",
    language: "es",
    category: "UTILITY",
    components: [
      { type: "HEADER", format: "IMAGE", example: PH },
      { type: "BODY", text: "📩 *{{1}}* te informa:\n\nHola {{2}} 👋\n\nEstas son tus prácticas programadas para esta semana:\n\n{{3}}\n\nPara cualquier cambio o cancelación, contáctanos por este chat." },
      { type: "BUTTONS", buttons: [{ type: "QUICK_REPLY", text: "Me viene bien" }, { type: "QUICK_REPLY", text: "Quiero cambiar algo" }] },
    ],
  },
  practica_asignada_crm_trial_img: {
    name: "practica_asignada_crm_trial_img",
    language: "es",
    category: "UTILITY",
    components: [
      { type: "HEADER", format: "IMAGE", example: PH },
      { type: "BODY", text: "📩 *{{1}}* te informa:\n\nHola {{2}},\n\nSe le ha asignado una práctica de {{5}} el {{3}} a las {{4}}.\n\n¡Te esperamos!" },
    ],
  },
  practica_recordatorio_crm_trial: {
    name: "practica_recordatorio_crm_trial",
    language: "es",
    category: "UTILITY",
    components: [
      { type: "HEADER", format: "TEXT", text: "RECORDATORIO DE PRÁCTICA" },
      { type: "BODY", text: "📩 *{{1}}* te envía este recordatorio:\n\nHola {{2}},\n\nLe recordamos que tiene una práctica el {{3}} a las {{4}}.\n\n¿Nos confirma su asistencia?" },
      { type: "BUTTONS", buttons: [{ type: "QUICK_REPLY", text: "Confirmar práctica" }, { type: "QUICK_REPLY", text: "Cancelar práctica" }] },
    ],
  },
  practica_modificada_crm_trial: {
    name: "practica_modificada_crm_trial",
    language: "es",
    category: "UTILITY",
    components: [
      { type: "BODY", text: "📩 *{{1}}* te informa:\n\nHola {{2}},\n\nTu {{3}} prevista para el {{4}} a las {{5}} ha sido modificada.\n\n📅 Nueva fecha: {{6}} a las {{7}}\n\n¿Nos confirmas tu asistencia?" },
      { type: "BUTTONS", buttons: [{ type: "QUICK_REPLY", text: "Confirmar práctica" }, { type: "QUICK_REPLY", text: "Cancelar práctica" }] },
    ],
  },
  practica_hueco_libre_trial: {
    name: "practica_hueco_libre_trial",
    language: "es",
    category: "UTILITY",
    components: [
      { type: "HEADER", format: "TEXT", text: "PRÁCTICA DISPONIBLE" },
      { type: "BODY", text: "📩 *{{1}}* te informa:\n\nHola {{2}},\n\nTenemos una práctica de {{3}} reservada para el {{4}} a las {{5}} con {{6}}.\n\nConfírmanos si la quieres y queda a tu nombre." },
      { type: "BUTTONS", buttons: [{ type: "QUICK_REPLY", text: "Lo quiero" }, { type: "QUICK_REPLY", text: "Ahora no" }] },
    ],
  },
  practica_cargo_cancelacion_trial: {
    name: "practica_cargo_cancelacion_trial",
    language: "es",
    category: "UTILITY",
    components: [
      { type: "BODY", text: "📩 *{{1}}* te informa:\n\nHola {{2}},\n\nTu práctica del {{3}} a las {{4}} se ha cancelado con menos de {{5}} horas de antelación.\n\nSegún las condiciones del centro, se ha añadido un cargo de {{6}} a tu cuenta. Puedes consultarlo con nosotros por este chat." },
    ],
  },
  test_teorica_diario_trial: {
    name: "test_teorica_diario_trial",
    language: "es",
    category: "UTILITY",
    components: [
      { type: "BODY", text: "📩 *{{1}}* te informa:\n\nHola {{2}}, tu test de teórica del {{3}} está listo: {{4}} preguntas del permiso {{5}}.\n\nPara dejar de recibirlo, escribe STOP TEST." },
      { type: "BUTTONS", buttons: [{ type: "QUICK_REPLY", text: "Hacer el test" }] },
    ],
  },
  cap_caducidad_alumno_trial: {
    name: "cap_caducidad_alumno_trial",
    language: "es",
    category: "MARKETING",
    components: [
      { type: "BODY", text: "📩 *{{1}}* te informa:\n\nHola {{2}},\n\nTu CAP caduca el {{3}}.\n\nSi quieres renovarlo a tiempo, responde a este mensaje y te ayudamos." },
    ],
  },
  examen_recordatorio_crm_trial_v2: {
    name: "examen_recordatorio_crm_trial_v2",
    language: "es",
    category: "UTILITY",
    components: [
      { type: "BODY", text: "📩 *{{1}}* te informa:\n\nHola {{2}}, te recordamos tu examen {{3}} el {{4}}{{5}}. ¡Mucha suerte!" },
      { type: "FOOTER", text: "Gracias por tu confianza" },
    ],
  },
  examen_resultado_crm_trial_v2: {
    name: "examen_resultado_crm_trial_v2",
    language: "es",
    category: "UTILITY",
    components: [
      { type: "BODY", text: "📩 *{{1}}* te informa:\n\nHola {{2}}, ya tenemos el resultado de tu examen de conducir {{3}}. El resultado ha sido: *{{4}}*. Para cualquier duda, no dudes en contactar con nosotros." },
      { type: "FOOTER", text: "Gracias por tu confianza" },
    ],
  },
  resena_google_autoescuela_trial: {
    name: "resena_google_autoescuela_trial",
    language: "es",
    category: "MARKETING",
    components: [
      { type: "BODY", text: "📩 *{{1}}* te escribe:\n\nHola {{2}}, gracias por confiar en nosotros para sacarte el carnet. 🚗\n\n¿Nos dejas una reseña sobre tu experiencia en la autoescuela? {{3}}\n\n¡Gracias por tu confianza! 🙏" },
      { type: "BUTTONS", buttons: [{ type: "URL", text: "Dejar reseña", url: "https://api.conextcrm.es/r/{{1}}" }] },
    ],
  },
  factura_alumno_autoescuela_trial: {
    name: "factura_alumno_autoescuela_trial",
    language: "es",
    category: "UTILITY",
    components: [
      { type: "HEADER", format: "DOCUMENT", example: PH },
      { type: "BODY", text: "Le escribe *{{1}}*.\n\nHola {{2}}, aquí tienes tu factura {{3}}. Gracias por confiar en nosotros para sacarte el carnet. 🚗" },
      { type: "FOOTER", text: "Conextcrm · Facturación" },
    ],
  },
  enlace_pago_crm_trial_v2: {
    name: "enlace_pago_crm_trial_v2",
    language: "es",
    category: "UTILITY",
    components: [
      { type: "BODY", text: "📩 *{{1}}* te informa:\n\nHola {{2}}, aquí tienes tu enlace para pagar {{3}}. Pulsa el botón para completar el pago de forma segura." },
      { type: "FOOTER", text: "Gracias por tu confianza" },
      { type: "BUTTONS", buttons: [{ type: "URL", text: "Pagar ahora", url: "https://api.conextcrm.es/p/{{1}}" }] },
    ],
  },
};

// ── Formato de fechas (el de los envíos reales) ─────────────────────────────────────────────────
const DOW = ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"];
const fecha = (d) => dayjs(d).format("DD/MM/YYYY");
const hora = (d) => dayjs(d).format("HH:mm");
const firstName = (name) => String(name || "").trim().split(/\s+/)[0] || "";
const ymdToFecha = (ymd) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(ymd || ""));
  return m ? `${m[3]}/${m[2]}/${m[1]}` : String(ymd || "");
};
const eur = (cents) => `${(Number(cents || 0) / 100).toFixed(2).replace(".", ",")} €`;
const TIPO_LABEL = { ciudad: "Ciudad", carretera: "Carretera", autovia: "Autovía", examen: "Examen", por_definir: "Por decidir" };

// fichaAlumnoText.js: «viernes, 2 de octubre» y «11:00» (Europe/Madrid).
function fechaLegible(iso) {
  return new Date(iso).toLocaleDateString("es-ES", { weekday: "long", day: "numeric", month: "long", timeZone: "Europe/Madrid" });
}

// ── Datos de la demo ────────────────────────────────────────────────────────────────────────────
const data = () => SECTOR_DATA_MAP.autoescuela || {};
const alumno = (id) => (data().mockAlumnos || []).find((a) => a.alumno_id === id) || null;
const practicasDe = (id) =>
  (data().mockPracticas || [])
    .filter((p) => (p.alumno_ids || []).includes(id))
    .slice()
    .sort((a, b) => a.start.localeCompare(b.start));
const profesor = (instId) => (data().mockInstructors || []).find((i) => i.instructor_id === instId) || null;
// En los avisos va el nombre de pila del profesor («Ana Belén», «Miguel Ángel»).
const profesorCorto = (instId) => {
  const p = profesor(instId);
  if (!p) return "Tu profesor";
  const parts = p.name.split(" ");
  return parts.length > 2 ? parts.slice(0, 2).join(" ") : parts[0];
};

// Prácticas «de la semana» de un alumno (las de Planificación de esta semana, sin el histórico, las
// clases teóricas, los exámenes, las canceladas ni las que reservó después por WhatsApp).
function semanaDe(id) {
  return practicasDe(id).filter(
    (p) => /^pr-\d/.test(p.practica_id) && p.status !== "cancelada" && !["examen", "clase", "por_definir"].includes(p.type),
  );
}
const lineaSemana = (p) =>
  `🗓️ ${DOW[dayjs(p.start).day()]} ${dayjs(p.start).format("DD/MM")} ${hora(p.start)} · ${TIPO_LABEL[p.type] || p.type} · ${profesorCorto(p.instructor_id)}`;

// ── Constructores de mensajes (forma de c_mensajes_optimized) ────────────────────────────────────
let _seq = 0;
const mid = (p) => `ae-${p}-${(_seq += 1)}`;
const SISTEMA = "system_autoescuela";
const OFICINA = "Carmen";

function out(ts, fields, { by = SISTEMA } = {}) {
  return {
    mensaje_id: mid("out"),
    timestamp: dayjs(ts).toISOString(),
    direction: "outbound",
    fromMe: true,
    messageStatus: "read",
    ...(by === SISTEMA ? { initiated_by: SISTEMA } : { sender_name: by }),
    ...fields,
  };
}
function inn(ts, fields) {
  return { mensaje_id: mid("in"), timestamp: dayjs(ts).toISOString(), direction: "inbound", fromMe: false, ...fields };
}
const text = (body) => ({ messageType: "text", messageBody: body });
function template(name, params, { buttonParams, image } = {}) {
  const tpl = AE_TEMPLATES[name];
  return {
    messageType: "template",
    messageBody: JSON.stringify({
      templateData: { ...tpl, parameter_format: "POSITIONAL" },
      templateParams: params,
      ...(buttonParams ? { buttonParams } : {}),
    }),
    ...(image ? { header_image: image } : {}),
  };
}
const pulsado = (title) => ({ messageType: "interactive", messageBody: JSON.stringify({ button_reply: { id: title, title } }) });
const flowEnviado = ({ body, footer, cta }) => ({
  messageType: "interactive",
  messageBody: JSON.stringify({ type: "flow", body: { text: body }, ...(footer ? { footer: { text: footer } } : {}), action: { name: "flow", parameters: { flow_cta: cta } } }),
});
const flowRespondido = (respuesta) => ({ messageType: "interactive", messageBody: JSON.stringify({ flow_completion: respuesta }) });

/**
 * Las marcas de tiempo deseadas pueden caer en el futuro según el día de la demo (p. ej. una práctica
 * del jueves vista un lunes). Se respetan en lo posible, pero cada mensaje queda después del anterior
 * y antes de ahora: la conversación siempre se lee en orden y nunca «del futuro».
 */
function normalizaLinea(msgs, now) {
  const t = msgs.map((m) => new Date(m.timestamp).getTime());
  for (let i = 1; i < t.length; i += 1) if (t[i] <= t[i - 1]) t[i] = t[i - 1] + 30_000;
  let tope = now - MIN;
  for (let i = t.length - 1; i >= 0; i -= 1) {
    if (t[i] > tope) t[i] = tope;
    tope = t[i] - 30_000;
  }
  return msgs.map((m, i) => ({ ...m, timestamp: new Date(t[i]).toISOString() }));
}

const diasAtras = (n, hh, mm = 0) => dayjs().subtract(n, "day").hour(hh).minute(mm).second(0).millisecond(0);
const minAtras = (n) => dayjs().subtract(n, "minute");

// ── Conversaciones ──────────────────────────────────────────────────────────────────────────────
function semanaConBotones(neg, a, primerAviso) {
  const lineas = semanaDe(a.alumno_id).map(lineaSemana);
  if (!lineas.length) return null;
  const clases = semanaDe(a.alumno_id).map((p) => ({
    dow: DOW[dayjs(p.start).day()],
    dia: String(dayjs(p.start).date()),
    hora: hora(p.start),
    tipo: TIPO_LABEL[p.type] || p.type,
    profesor: profesorCorto(p.instructor_id),
  }));
  return {
    ts: primerAviso,
    msg: template("practicas_semana_crm_trial_img_btn", [neg, firstName(a.name), lineas.join(" • ")], {
      image: { kind: "semana", lineas, clases, alumno: firstName(a.name) },
    }),
  };
}

// Domingo (o el día antes de la primera práctica) a las 19:00: cuando se manda la semana.
function envioSemana(id) {
  const primera = semanaDe(id)[0];
  return primera ? dayjs(primera.start).subtract(1, "day").hour(19).minute(0) : diasAtras(5, 19);
}

// El recordatorio más reciente que ya ha salido (24 h antes de la práctica) de un alumno.
function ultimaRecordada(id, filtro) {
  const ahora = Date.now();
  const cands = practicasDe(id).filter((p) => filtro(p) && new Date(p.start).getTime() - 24 * 3600 * 1000 <= ahora - 30 * MIN);
  return cands[cands.length - 1] || null;
}

function alejandro(neg) {
  const a = alumno("alu-001");
  if (!a) return null;
  const n = firstName(a.name);
  const msgs = [];
  const sem = semanaConBotones(neg, a, envioSemana(a.alumno_id));
  if (sem) {
    msgs.push(out(sem.ts, sem.msg));
    msgs.push(inn(dayjs(sem.ts).add(12, "minute"), pulsado(BOTON.meVieneBien)));
    msgs.push(out(dayjs(sem.ts).add(12, "minute"), text(`${prefijoConext(neg)}${SEMANA.meVieneBien(n)}`)));
  }
  // Recordatorio de práctica → «Confirmar práctica». Sin «dar las gracias al confirmar» (de fábrica
  // apagado) no se le contesta: solo se marca como leído y la práctica queda Confirmada.
  const pr = ultimaRecordada(a.alumno_id, (p) => p.status !== "cancelada" && !["examen", "clase"].includes(p.type));
  const recTs = pr ? dayjs(pr.start).subtract(24, "hour") : diasAtras(1, 10);
  const recPr = pr ? dayjs(pr.start) : recTs.add(24, "hour");
  msgs.push(out(recTs, template("practica_recordatorio_crm_trial", [neg, n, fecha(recPr), hora(recPr)])));
  msgs.push(inn(recTs.add(41, "minute"), pulsado(BOTON.confirmar)));

  // Aviso de caducidad del CAP → quiere renovarlo → la autoescuela le apunta al CAP continuo.
  if (a.cap?.caducidad) {
    const ed = getEdicionSync("ed-cap-continuo-1");
    const s1 = ed?.edicion?.sesiones?.[0];
    const capTs = diasAtras(2, 10, 0);
    msgs.push(out(capTs, template("cap_caducidad_alumno_trial", [neg, n, ymdToFecha(a.cap.caducidad)])));
    msgs.push(inn(capTs.add(2, "hour").add(28, "minute"), text("Hola! Sí, quiero renovarlo. ¿Cuándo es el próximo curso?")));
    msgs.push(out(capTs.add(3, "hour").add(5, "minute"), text(
      `${prefijoConext(neg)}¡Hola ${n}! El próximo CAP de formación continua empieza el ${s1 ? ymdToFecha(s1.fecha) : "lunes"} a las ${s1 ? s1.inicio : "08:00"} en ${ed?.edicion?.lugar || "la autoescuela"}. Te he apuntado ya: el día antes te llega el recordatorio por aquí.`,
    ), { by: OFICINA }));
    msgs.push(inn(capTs.add(3, "hour").add(9, "minute"), text("Perfecto, muchas gracias!! 🙌")));
  }

  // «mi ficha» → su ficha (c_processMessage/fichaAlumnoText.js).
  const ahora = dayjs();
  const proximas = practicasDe(a.alumno_id).filter((p) => p.status !== "cancelada" && p.type !== "clase" && dayjs(p.start).isAfter(ahora));
  const clases = proximas.filter((p) => p.type !== "examen").slice(0, 3);
  const examen = proximas.find((p) => p.type === "examen");
  const bloques = [];
  if (clases.length) {
    bloques.push(`*Tus próximas clases*\n${clases.map((p) => `• ${fechaLegible(p.start)} a las ${hora(p.start)} con ${profesor(p.instructor_id)?.name || "tu profesor"}`).join("\n")}`);
  }
  bloques.push("*Tu saldo*\n• Te quedan 4 clases de tu bono Pack 10 prácticas");
  bloques.push("*Cómo vas*\n• Maniobras: a mejorar\n• Circulación en ciudad: dominado\n• Carretera: bien\n• Autovía: bien\n• Aparcamiento: a mejorar");
  if (examen) bloques.push(`*Tus exámenes*\n• Próximo: práctico el ${fecha(examen.start)}`);
  msgs.push(inn(minAtras(36), text("mi ficha")));
  msgs.push(out(minAtras(36), text(`${prefijoConext(neg)}${[`Hola ${a.name}, esto es lo que tenemos de ti:`, ...bloques].join("\n\n")}`)));
  return { a, msgs, unread: 0 };
}

function sofia(neg) {
  const a = alumno("alu-002");
  if (!a) return null;
  const n = firstName(a.name);
  const msgs = [];
  const sem = semanaConBotones(neg, a, envioSemana(a.alumno_id));
  if (sem) {
    msgs.push(out(sem.ts, sem.msg));
    const t = dayjs(sem.ts);
    msgs.push(inn(t.add(63, "minute"), pulsado(BOTON.quieroCambiar)));
    msgs.push(out(t.add(63, "minute"), text(`${prefijoConext(neg)}${SEMANA.quieroCambiar}`)));
    msgs.push(inn(t.add(65, "minute"), text(SEMANA.ejemplo)));
    msgs.push(out(t.add(65, "minute"), text(`${prefijoConext(neg)}${SEMANA.recibido}`)));
    // La oficina la mueve a mano: del martes al miércoles por la tarde, y le llega el aviso con botones.
    const martes = semanaDe(a.alumno_id).find((p) => dayjs(p.start).day() === 2) || semanaDe(a.alumno_id)[1] || semanaDe(a.alumno_id)[0];
    const ant = dayjs(martes.start);
    const nueva = ant.add(1, "day").hour(17).minute(0);
    const prof = profesorCorto(martes.instructor_id);
    msgs.push(out(t.add(14, "hour").add(12, "minute"), text(
      `${prefijoConext(neg)}Hola ${n}, sin problema: te pasamos la práctica del martes al miércoles a las 17:00 con ${prof}. Ahora te llega el aviso con la nueva hora 👍`,
    ), { by: OFICINA }));
    msgs.push(out(t.add(14, "hour").add(13, "minute"), template("practica_modificada_crm_trial", [
      neg, n, `práctica de ${TIPO_LABEL[martes.type] || "Ciudad"}`, fecha(ant), hora(ant), fecha(nueva), hora(nueva),
    ])));
    msgs.push(inn(t.add(14, "hour").add(20, "minute"), pulsado(BOTON.confirmar)));
    msgs.push(inn(t.add(14, "hour").add(21, "minute"), text("Mil gracias!! 😊")));
  }
  // «Quiero clase» → Flow de pedir clase → su petición → acuse (c_processMessage/pedirPractica.js).
  const peticion = { tipo: "ciudad", dias: ["jueves", "viernes"], franja: "tarde", nota: "Mejor a partir de las 17:00, salgo de clase a las 16:30" };
  const q = diasAtras(1, 18, 40);
  msgs.push(inn(q, text("Quiero clase")));
  msgs.push(out(q, flowEnviado({ body: `${prefijoConext(neg)}${FLOW_PEDIR.texto}`, footer: FLOW_PEDIR.pie, cta: FLOW_PEDIR.cta })));
  msgs.push(inn(q.add(2, "minute"), flowRespondido(peticion)));
  msgs.push(out(q.add(2, "minute"), text(`${prefijoConext(neg)}${buildAcuseText(peticion, { nombre: n })}`)));
  return { a, msgs, unread: 0 };
}

function hugo(neg) {
  const a = alumno("alu-003");
  if (!a) return null;
  const n = firstName(a.name);
  const msgs = [];
  const exam = diasAtras(8, 9, 30);
  const rec = diasAtras(9, 10, 0);
  msgs.push(out(rec, template("examen_recordatorio_crm_trial_v2", [neg, n, "práctico", fecha(exam), ` a las ${hora(exam)}`])));
  msgs.push(inn(rec.add(22, "minute"), text("Gracias!! Estoy un poco nervioso 😅")));
  msgs.push(out(rec.add(30, "minute"), text(
    `${prefijoConext(neg)}Tranquilo, ${n}, lo llevas muy bien. Descansa esta noche y mañana a las 08:45 te esperamos en la autoescuela para calentar motores 💪`,
  ), { by: OFICINA }));
  const res = diasAtras(8, 13, 15);
  msgs.push(out(res, template("examen_resultado_crm_trial_v2", [neg, n, "práctico", "APTO"])));
  msgs.push(inn(res.add(5, "minute"), text("¡¡APROBADO A LA PRIMERA!! 🎉🎉 Muchísimas gracias a todos, sobre todo a Miguel Ángel")));
  msgs.push(out(res.add(9, "minute"), text(
    `${prefijoConext(neg)}¡Enhorabuena, ${n}! 👏 Te lo has ganado. Disfruta mucho del carnet y conduce con cabeza 🚗`,
  ), { by: OFICINA }));
  msgs.push(out(res.add(12, "minute"), template("factura_alumno_autoescuela_trial", [neg, n, "FAC-2026-0031"])));
  // Al día siguiente, la petición de reseña (c_sendAlumnoReviewReminder, cláusula sin descuento).
  const rev = diasAtras(7, 11, 0);
  msgs.push(out(rev, template("resena_google_autoescuela_trial", [neg, n, "Tu opinión nos ayuda muchísimo."], {
    buttonParams: [{ index: 0, sub_type: "url", value: "hF7k2Qa" }],
  })));
  msgs.push(inn(rev.add(48, "minute"), text("Hecho! 5 estrellas ⭐⭐⭐⭐⭐")));
  return { a, msgs, unread: 0 };
}

function lucia(neg) {
  const a = alumno("alu-004");
  if (!a) return null;
  const n = firstName(a.name);
  const msgs = [];
  // Práctica asignada con la imagen de la clase en la cabecera: su primera práctica de A2.
  const primera = practicasDe(a.alumno_id).find((p) => /Primera práctica/i.test(p.notas || "")) ||
    practicasDe(a.alumno_id).find((p) => p.status === "pendiente");
  if (primera) {
    const ts = diasAtras(6, 12, 0);
    const tipo = TIPO_LABEL[primera.type] || "Ciudad";
    msgs.push(out(ts, template("practica_asignada_crm_trial_img", [neg, n, fecha(primera.start), hora(primera.start), tipo], {
      image: { kind: "asignada", fecha: fecha(primera.start), hora: hora(primera.start), tipo, alumno: n },
    })));
    msgs.push(inn(ts.add(30, "minute"), text("Genial!! Qué ganas de empezar con la moto 🏍️")));
  }
  // Recordatorio → «Cancelar práctica» → respuesta (practicaCancelReply) y, si canceló tarde con cobro,
  // el aviso del cargo (practica_cargo_cancelacion_trial).
  const canc = ultimaRecordada(a.alumno_id, (p) => p.status === "cancelada");
  if (canc) {
    const st = dayjs(canc.start);
    const rec = st.subtract(24, "hour");
    const tarde = canc.late_cancellation?.applied;
    const pulsa = tarde ? st.subtract(3, "hour") : rec.add(70, "minute");
    msgs.push(out(rec, template("practica_recordatorio_crm_trial", [neg, n, fecha(st), hora(st)])));
    msgs.push(inn(pulsa, pulsado(BOTON.cancelar)));
    msgs.push(out(pulsa, text(`${prefijoConext(neg)}${practicaCancelReply(getReminderConfig().cancel_contact_phone)}`)));
    if (tarde) {
      msgs.push(out(pulsa.add(20, "minute"), template("practica_cargo_cancelacion_trial", [neg, n, fecha(st), hora(st), "24", eurosCargo(canc.late_cancellation.amount_cents)])));
    }
  }
  // Test de teórica del día por WhatsApp: aviso con «Hacer el test» → el test (Flow) → la nota.
  const tt = diasAtras(1, 20, 0);
  const ej = ejemploTest({ longitud: 10 });
  msgs.push(out(tt, template("test_teorica_diario_trial", [neg, n, tt.format("DD/MM"), "10", "A2"])));
  msgs.push(inn(tt.add(7, "minute"), pulsado(BOTON_PLANTILLA)));
  msgs.push(out(tt.add(7, "minute"), flowEnviado({ body: `${prefijoConext(neg)}${testText({ longitud: 10, permiso: "A2" })}`, cta: CTA_TEST })));
  msgs.push(out(tt.add(16, "minute"), text(`${prefijoConext(neg)}${ej.notaWhatsApp}`)));
  // Hoy: una duda sin contestar.
  msgs.push(inn(minAtras(14), text("Una pregunta: para la práctica de la moto, ¿tengo que llevar mi casco o me lo dejáis vosotros? 🏍️")));
  return { a, msgs, unread: 1 };
}

function pablo(neg) {
  const a = alumno("alu-005");
  if (!a) return null;
  const n = firstName(a.name);
  const msgs = [];
  const q = diasAtras(3, 11, 5);
  msgs.push(inn(q, text("Buenas! Quiero retomar las clases. ¿Puedo llevar a mi hermano de acompañante en las prácticas? Así ve cómo va, que él también se quiere apuntar")));
  msgs.push(out(q.add(35, "minute"), text(
    `${prefijoConext(neg)}¡Hola ${n}! Qué bien que vuelvas. En las prácticas solo vais tú y el profesor (lo exige el seguro), pero tu hermano puede pasarse por la oficina y le contamos todo sin compromiso 😊`,
  ), { by: OFICINA }));
  msgs.push(inn(q.add(52, "minute"), text("Vale perfecto. ¿Me mandáis lo del bono de 10 para pagarlo?")));
  const pago = diasAtras(2, 10, 15);
  msgs.push(out(pago, template("enlace_pago_crm_trial_v2", [neg, n, "el bono de 10 prácticas"], {
    buttonParams: [{ index: 0, sub_type: "url", value: "cs_live_b1Qx7RkP2s" }],
  }), { by: OFICINA }));
  msgs.push(inn(pago.add(16, "minute"), text("Ya está pagado 👍 ¿Cuándo empiezo?")));
  return { a, msgs, unread: 1 };
}

function marta(neg) {
  const a = alumno("alu-006");
  if (!a) return null;
  const n = firstName(a.name);
  const msgs = [];
  // Inscripción a un curso CAP por el enlace con código CUR-… (c_cursoWhatsapp).
  const det = getEdicionSync("ed-cap-continuo-1");
  const ed = det?.edicion;
  if (ed) {
    const s = (ed.sesiones || []).slice().sort((x, y) => `${x.fecha}${x.inicio}`.localeCompare(`${y.fecha}${y.inicio}`));
    const p = s[0];
    const cuando = p ? `el ${ymdToFecha(p.fecha)} a las ${p.inicio}` : "";
    const sesiones = s.length > 1 ? `\n\nSon ${s.length} sesiones:\n${s.map((x) => `• ${ymdToFecha(x.fecha)} de ${x.inicio} a ${x.fin}`).join("\n")}` : "";
    const t = diasAtras(10, 18, 20);
    msgs.push(inn(t, text(`Quiero apuntarme al curso ${ed.curso_nombre} (código ${ed.codigo})`)));
    msgs.push(out(t, flowEnviado({
      body: `${prefijoConext(neg)}Para apuntarte a *${ed.curso_nombre}* (empieza ${cuando}), rellena tus datos. Es un minuto.`,
      footer: neg.slice(0, 60),
      cta: "Apuntarme",
    })));
    msgs.push(inn(t.add(4, "minute"), flowRespondido({
      nombre: n, apellidos: a.name.split(" ").slice(1).join(" "), dni: a.dni, email: "marta.lopez@gmail.com", permiso: "C", cap_caducidad: a.cap?.caducidad || "",
    })));
    const plaza = `✅ Plaza reservada, ${n}.\n\n*${ed.curso_nombre}* · ${neg}\nEmpieza ${cuando} en ${ed.lugar || "la autoescuela"}.${sesiones}\n\nEl día antes te mandamos un recordatorio por aquí.`;
    const pago = det.precio_cents > 0 ? `\n\nPara dejar tu plaza pagada (${eur(det.precio_cents)}), puedes hacerlo aquí:\nhttps://api.conextcrm.es/p/cs_live_a4Mf2LwQ9n` : "";
    msgs.push(out(t.add(4, "minute"), text(`${prefijoConext(neg)}${plaza}${pago}`)));
    msgs.push(inn(t.add(19, "minute"), text("Pagado! Gracias 🙌")));
  }
  // Hueco liberado ofrecido por WhatsApp → «Lo quiero» → es suya (c_offerPracticaSlot).
  const hueco = practicasDe(a.alumno_id).find((p) => p.creation_source === "slot_fill");
  const hs = hueco ? dayjs(hueco.start) : diasAtras(5, 11, 0);
  const of = hs.subtract(2, "hour").subtract(55, "minute");
  msgs.push(out(of, template("practica_hueco_libre_trial", [
    neg, n, TIPO_LABEL[hueco?.type] || "Ciudad", fecha(hs), hora(hs), hueco ? profesorCorto(hueco.instructor_id) : "tu profesor",
  ])));
  msgs.push(inn(of.add(2, "minute"), pulsado(BOTON.loQuiero)));
  msgs.push(out(of.add(2, "minute"), text(`${prefijoConext(neg)}${HUECO.ganada}`)));
  msgs.push(inn(of.add(3, "minute"), text("Bieen, justo me venía genial 🙌")));
  return { a, msgs, unread: 0 };
}

// Alguien que todavía NO es alumno (en la real sale «Dar de alta como alumno» en la cabecera).
export const LEAD_DEMO = { name: "Irene Castro", phone: "+34622418905" };
function irene(neg) {
  const msgs = [];
  msgs.push(inn(minAtras(52), text("Hola! ¿Cuánto cuesta el pack de 10 prácticas? ¿Y la matrícula?")));
  msgs.push(out(minAtras(44), text(
    `${prefijoConext(neg)}¡Hola Irene! El pack de 10 prácticas son 270 € y la matrícula con las tasas de la DGT, 80 €. Si te matriculas esta semana, la primera práctica te la regalamos 😉`,
  ), { by: OFICINA }));
  msgs.push(inn(minAtras(9), text("Vale! ¿Y podría empezar ya la semana que viene?")));
  return { a: null, name: LEAD_DEMO.name, phone: LEAD_DEMO.phone, msgs, unread: 1 };
}

// ── Store en memoria (los mensajes que se envían en la demo y los «leídos» duran la sesión) ──────
let _convs = null;

function build() {
  const neg = getBusinessName();
  const now = Date.now();
  return [alejandro, sofia, hugo, lucia, pablo, marta, irene]
    .map((f) => f(neg))
    .filter(Boolean)
    .map((c) => {
      const phone = c.a ? c.a.phone : c.phone;
      return {
        alumno_id: c.a ? c.a.alumno_id : null,
        nombre: c.a ? c.a.name : c.name,
        phone_number: phone,
        contact_id: `${AE_CHAT_COMPANY}#${phone}`,
        unread_count: c.unread,
        // Orden por la hora deseada (estable: la respuesta va detrás del botón aunque coincidan).
        messages: normalizaLinea([...c.msgs].sort((x, y) => x.timestamp.localeCompare(y.timestamp)), now),
      };
    });
}

function convs() {
  if (!_convs) _convs = build();
  return _convs;
}

/** Texto corto del último mensaje para la lista (como el snippet de c_chats). */
export function snippetOf(m) {
  if (!m) return "";
  if (m.messageType === "template") {
    try {
      const { templateData } = JSON.parse(m.messageBody);
      return JSON.stringify({ templateData: { name: templateData.name } });
    } catch {
      return "";
    }
  }
  if (m.messageType === "interactive") {
    try {
      const p = JSON.parse(m.messageBody);
      if (p.button_reply) return p.button_reply.title;
      if (p.flow_completion) return "Formulario enviado";
      if (p.type === "flow") return String(p.body?.text || "").replace(/^📩 \*[^*]+\* te escribe:\s*/, "");
    } catch {
      return "";
    }
  }
  if (m.messageType === "location") return "📍 Ubicación";
  if (m.messageType === "document") return `📄 ${m.filename || "Documento"}`;
  return String(m.messageBody || "").replace(/^📩 \*[^*]+\* te escribe:\s*/, "").replace(/\s+/g, " ").trim();
}

function toListItem(c) {
  const last = c.messages[c.messages.length - 1];
  const lastIn = [...c.messages].reverse().find((m) => !m.fromMe);
  return {
    company_id: AE_CHAT_COMPANY,
    contact_id: c.contact_id,
    alumno_id: c.alumno_id,
    nombre: c.nombre,
    phone_number: c.phone_number,
    snippet: snippetOf(last),
    snippet_from_me: !!last?.fromMe,
    snippet_status: last?.fromMe ? last.messageStatus : undefined,
    last_outgoing_msg_id: last?.fromMe ? last.mensaje_id : undefined,
    last_msg_ts: last?.timestamp,
    // Ventana de 24 h de WhatsApp: desde el último mensaje del alumno.
    active_until: lastIn ? new Date(new Date(lastIn.timestamp).getTime() + 24 * 3600 * 1000).toISOString() : null,
    channel: "whatsapp",
    unread_count: c.unread_count,
  };
}

/** Lista de chats (forma de /chat-list/unified), del más reciente al más antiguo. */
export function getAutoescuelaChatList() {
  return convs()
    .map(toListItem)
    .sort((a, b) => String(b.last_msg_ts).localeCompare(String(a.last_msg_ts)));
}

/** Mensajes de un chat, en orden. [] si no existe. */
export function getAutoescuelaChatMessages(contactId) {
  const c = convs().find((x) => x.contact_id === contactId);
  return c ? [...c.messages] : [];
}

/** Abrir un chat lo marca como leído (como c_markChatRead). */
export function markAutoescuelaChatRead(contactId) {
  const c = convs().find((x) => x.contact_id === contactId);
  if (c) c.unread_count = 0;
}

/** Añade un mensaje (lo que escribe la autoescuela en la demo o la respuesta simulada del alumno). */
export function appendAutoescuelaChatMessage(contactId, msg) {
  const c = convs().find((x) => x.contact_id === contactId);
  if (!c) return null;
  const m = { mensaje_id: mid(msg.fromMe ? "out" : "in"), timestamp: new Date().toISOString(), ...msg };
  c.messages.push(m);
  return m;
}

/** Cambia nombre/alumno de un chat (al dar de alta o editar el alumno desde la cabecera). */
export function updateAutoescuelaChat(contactId, patch) {
  const c = convs().find((x) => x.contact_id === contactId);
  if (c) Object.assign(c, patch);
}

export const textoConPrefijo = (texto) => `${prefijoConext(getBusinessName())}${texto}`;

/** Solo para tests y para «Reiniciar demo»: vuelve a construir las conversaciones. */
export function resetAutoescuelaChats() {
  _convs = null;
}
